import { action, computed, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class InvoiceTax extends Model {
  /**
   * @property {number|null}
   */
  @observable invoiceTaxId = null;

  /**
   * @property {number|null}
   */
  @observable taxId = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable taxNumbers = null;

  /**
   * @property {number|null}
   */
  @observable rate = null;

  /**
   * @property {number|null}
   */
  @observable amount = null;

  /**
   * @property {number|null}
   */
  @observable ordering = null;

  /**
   * @property {string|null}
   */
  @observable creationDts = null;

  /**
   * @property {string|null}
   */
  @observable modificationDts = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { creationDts, modificationDts, ...rest } = data;
    set(this, rest);

    this.creationDts = creationDts ? moment.unix(creationDts) : null;
    this.modificationDts = modificationDts ? moment.unix(modificationDts) : null;
  }

  @computed
  get displayName() {
    if (!this.taxNumbers) {
      return this.name;
    }

    return `${this.name} (${this.taxNumbers})`;
  }
}

export default InvoiceTax;
